import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getScheduledTasks = api(async function getScheduledTasks() {
    return query(
        gql`
            query Schedule {
                getScheduledTasks
            }
        `,
        {},
        { returns: "getScheduledTasks" }
    )
})
